module.exports = __webpack_public_path__ + "img/Malaysia-hover.85336bfa.jpg";